import {
  PEELING_WASTAGE_FAILED,
  PEELING_WASTAGE_REQUEST,
  PEELING_WASTAGE_SUCCESS,
} from "app/redux/actions/Factory/Peeling/peelingWastage/constant";

const INIT_STATE = {
  loading: false,
  totalPage: 0,
  data: [],
  error: {
    isError: false,
    message: null,
  },
};

export const peelingWastageReducer = function (state = INIT_STATE, action) {
  switch (action?.type) {
    case PEELING_WASTAGE_REQUEST:
      return {
        loading: true,
        totalPage: 0,
        data: [],
        error: {
          isError: false,
          message: null,
        },
      };
    case PEELING_WASTAGE_SUCCESS:
      return {
        loading: false,
        data: action?.payload?.data,
        totalPage: action?.payload?.totalPage,
        error: {
          isError: false,
          message: null,
        },
      };
    case PEELING_WASTAGE_FAILED:
      const { isError = true, message = "Something Went Wrong" } =
        action?.payload?.error || {};
      return {
        loading: false,
        totalPage: 0,
        data: [],
        error: {
          isError: isError,
          message: message,
        },
      };
    default:
      return state;
  }
};
